import moment from 'moment'
import React from 'react'
import { Provider } from 'react-redux'
import { hot } from 'react-hot-loader/root'
import NotificationSystem from 'react-notification-system'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import * as Sentry from '@sentry/browser'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet'
import aphroditeInterface from 'react-with-styles-interface-aphrodite'
import DefaultTheme from 'react-dates/lib/theme/DefaultTheme'

ThemedStyleSheet.registerInterface(aphroditeInterface)
ThemedStyleSheet.registerTheme(DefaultTheme)

moment.locale('ru')

import DashboardLayout from './components/DashboardLayout'

if (CLIENT_SENTRY_DSN) {
  Sentry.init({ dsn: CLIENT_SENTRY_DSN })
}

class Application extends React.Component {

  notificationSystem = React.createRef()

  componentDidMount() {
    window.NotificationManager = this.notificationSystem.current
  }

  render() {
    const { store } = this.props
    return (
      <Provider store={store}>
        <Router basename={PATH_PREFIX}>
          <Route path='/:categoryId?' component={DashboardLayout}/>
        </Router>
        <NotificationSystem ref={this.notificationSystem} />
      </Provider>
    )
  }

}


export default hot(Application)